let openCount = 0

export function lockModalBodyScroll() {
  if (typeof document === 'undefined') return
  openCount += 1
  if (openCount === 1) {
    document.body.classList.add('modal-open')
    document.body.style.overflow = 'hidden'
  }
}

export function unlockModalBodyScroll() {
  if (typeof document === 'undefined') return
  openCount = Math.max(0, openCount - 1)
  if (openCount === 0) {
    document.body.classList.remove('modal-open')
    document.body.style.overflow = ''
  }
}
